// extracted by mini-css-extract-plugin
module.exports = {"scansTab":"LensModal_scansTab__3YiLB"};